// import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_cloud_alfa.png",
      alt: "Nome da extensão",
    },
    title: "Transformando Dados em Performance! ",
    text: [
      "Atuantes desde 2019, combinamos inteligência estatística, tecnologia e experiência de mercado para criar carteiras automatizadas com consistência e controle de risco. Nossas estratégias são baseadas em dados históricos e modelagem estatística avançada, entregando performance real, previsível e monitorada diariamente.",
      "Com portfólios otimizados que combinam estratégias de forma inteligente, simplificamos a vida do cliente e mantemos o foco total na gestão de risco. ",
    ],
    testimonial: {
      text: "Todo investidor deveria ter automação em seu portfólio. Estamos aqui para facilitar este processo, com inteligência estatística para transformar dados em Alfa: resultados consistentes, acima dos benchmarks e com controle de risco.",
      author: {
        name: "Cleiton Oliveira e Rogerio Szterling, co-fundadores da Cloud Alfa",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Alguns números da Cloud Alfa",
    subtitle: "Inteligência estatística: consistência com gestão de risco",
    data: [
      {
        value: "+40",
        description: "Anos de experiência combinada",
      },
      {
        value: "+86%",
        description: "Meses acima do benchmark",
      },
      {
        value: "+10k",
        description: "Clientes de nossas estratégias",
      },
      {
        value: "+2",
        description: "Milhões de testes realizados",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Cloud Alfa?",
    subtitle: "Veja quais as principais vantagens dos robôs da Cloud Alfa.",
    data: [
      {
        title: "Acesso a inteligência de mercado",
        description:
          "Você opera com modelos construídos a partir de anos de experiência e testes estatísticos rigorosos, desenvolvidos por especialistas certificados ANBIMA e APIMEC. É como ter um time de traders profissionais ao seu lado, 24 horas por dia.",
      },
      {
        title: "Diversificação e escalabilidade",
        description:
          "Nossas carteiras permitem rodar múltiplas estratégias simultaneamente, com diferentes perfis e horizontes temporais. Isso equilibra risco e aumenta o potencial de performance do portfólio como um todo.",
      },
      {
        title: "Track record comprovado",
        description:
          "Estratégias testadas no tempo: diversas delas rodam há anos em nossas próprias contas e são validadas com dados históricos de alta qualidade desde 2015.",
      },
      {
        title: "Robustez estatística",
        description:
          "Cada estratégia passa por milhares de testes, utilizando técnicas avançadas como simulações de Monte Carlo, validações cruzadas e otimizações walk-forward, garantindo maior confiabilidade em diferentes cenários de mercado.",
      },
      {
        title: "Premiações reais",
        description:
          "1.º lugar em “menor drawdown” e Top 10 em “maior retorno” no Campeonato Brasileiro de Robôs Traders 2024 – reconhecimento nacional da qualidade de nossos modelos.",
      },
      {
        title: "Gestão de Risco inteligente",
        description:
          "Nossos robôs aplicam limites, filtros e proteções automaticamente, evitando operações fora do plano. Contam com controles de volatilidade, volume, horários críticos e outras variáveis impossíveis de acompanhar manualmente com precisão.",
      },
    ],
  },
  cta: {
    title: "Sim, quero trazer mais Alfa para minha carteira!",
    subtitle: "Escolha seu plano!",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Cloud Alfa",
    col1: [
      "Está no nome e no nosso DNA: nossa missão é gerar retornos consistentes acima dos índices de referência. Isso é ALFA.",
      "Somos especialistas em estratégias de investimento automatizadas, fundamentadas em estatística avançada e projetadas para se adaptar continuamente às mudanças do mercado. A Cloud Alfa foi fundada por Cleiton Oliveira, especialista em investimentos certificado pela ANBIMA (CEA), e Rogerio Szterling, engenheiro pela UNICAMP e profissional de investimentos certificado pela APIMEC (CNPI). Juntos, somamos mais de 40 anos de experiência em Finanças, Estatística e Tecnologia. ",
    ],
    col2: [
      "Desde 2019, nossas estratégias entregam resultados consistentes em contas próprias e podem ser ajustadas para diferentes perfis de investidor. Acreditamos que todo portfólio se beneficia de uma dose de automação e é isso que buscamos proporcionar. ",
      "Nossos modelos fogem do lugar comum: vão além da análise gráfica tradicional ao integrar múltiplas informações e correlações de mercado, calculando probabilidades para oferecer a melhor relação risco/retorno em cada cenário. ",
      "Em um mercado cada vez mais dinâmico e competitivo, operamos com total ética e verdadeiro skin in the game: monitoramos e aprimoramos continuamente cada estratégia que colocamos em prática. ",
      "Traga mais Alfa para sua carteira. Invista com a Cloud Alfa. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Cloud Alfa",
  },
  strategies: {
    title: "Estratégias e Carteiras Cloud Alfa",
    heading: "Estratégias e Carteiras balanceadas e diversificadas, para todos os tipos de investidores",
    subtitle:
      "Com dezenas de estratégias em paper trade há anos, nossas carteiras combinam diferentes estilos operacionais e baixo nível de correlação. Cada portfólio é construído com foco em consistência, eficiência operacional e controle de drawdown. Ative em sua conta com poucos cliques! ",
  },
  testimonials: [
    {
      text: "A experiência tem sido uma grata surpresa. Com pouco investimento inicial, já estou vendo excelentes resultados. Gostei tanto que recomendei ao meu filho e a diversos amigos. É uma ótima oportunidade para quem não tem tempo para acompanhar a gestão. E, precisando, auxiliam desde a abertura das contas até toda a parte tecnológica.",
      author: "Enio Antonio Papaiz Jr",
      job: "Publicitário",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Assinei depois de comparar várias estratégias do mercado. Enquanto muitos robôs têm pouco histórico real e dependem de backtests ajustados demais, a Cloud Alfa se destaca por anos de desempenho transparente e comprovado. Após alguns meses usando, os resultados confirmam exatamente o que os gráficos já mostravam: consistência real..",
      author: "Álvaro Augusto",
      job: "Cabeleireiro",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Sou cliente há um bom tempo e recomendo sem hesitar. As estratégias são consistentes, o suporte é rápido e técnico, e a transparência da empresa passa muita confiança. É raro encontrar esse nível de seriedade no mercado.",
      author: "Joscelino Oliveira",
      job: "Trader Profissional",
    },
  ],
};
